import { useEffect } from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CoursesOverview from "components/CoursesOverview";
import FormattedMessage from "components/FormattedMessage";
import { PlanOrderCard } from "components/PlanOrderCard";
import { PlanOverviewCard } from "components/PlanOverviewCard";
import {
  getChargebeePortalSession,
  useAppointments,
  usePlans,
} from "services/mms";
import { useCurrentUser } from "services/user";

import messages from "./messages";

const useStyles = makeStyles((theme) => ({
  centerSmall: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      alignItems: "center",
    },
  },
  root: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    padding: theme.spacing(4),
  },
  subscriptionsAndPackages: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      justifyContent: "center",
    },
  },
}));

/* eslint-disable react/prefer-stateless-function */
const HomePage = () => {
  const { data: user } = useCurrentUser();
  const classes = useStyles();

  const handleOpenModal = async ({ customer_id, subscription_id }) => {
    const cbInstance = window.Chargebee.getInstance();

    cbInstance.setPortalSession(
      async () =>
        await getChargebeePortalSession({
          customer_id,
          subscription_id,
          user,
        })
    );

    const portal = cbInstance.createChargebeePortal();
    portal.openSection(
      {
        params: {
          subscriptionId: subscription_id,
        },
        sectionType: window.Chargebee.getPortalSections().SUBSCRIPTION_DETAILS,
      },
      {
        close: () => {
          console.log("Chargebee portal closed");
        },
        loaded: () => {
          console.log("Chargebee portal loaded");
        },
      }
    );
  };

  const handleOpenInvoiceHistoryModal = async () => {
    const customer_id = plans?.all?.[0]?.customer_id;
    if (!customer_id) return;

    const cbInstance = window.Chargebee.getInstance();

    cbInstance.setPortalSession(
      async () =>
        await getChargebeePortalSession({
          customer_id,
          user,
        })
    );

    const portal = cbInstance.createChargebeePortal();
    portal.openSection(
      {
        sectionType: window.Chargebee.getPortalSections().BILLING_HISTORY,
      },
      {
        close: () => {
          console.log("Chargebee invoice history closed");
        },
        loaded: () => {
          console.log("Chargebee invoice history loaded");
        },
      }
    );
  };

  useEffect(() => {
    document.title = "Home";
    if (window.Chargebee) {
      window.Chargebee.init({
        site: "mymusicschool",
      });
    }
  }, [user]);

  // Prefetch appointments
  void useAppointments();

  const { data: plans } = usePlans();

  return (
    <div className={classes.root}>
      <Typography className={classes.centerSmall} variant="h5">
        <FormattedMessage {...messages.subscriptionAndPackages} />
      </Typography>
      <div className={classes.subscriptionsAndPackages}>
        {plans?.all &&
          plans.all.map((plan) => (
            <PlanOverviewCard
              key={plan.certificate}
              plan={plan}
              onOpenModal={handleOpenModal}
            />
          ))}
        <PlanOrderCard
          customerId={plans?.all?.[0]?.customer_id}
          onOpenInvoiceHistory={handleOpenInvoiceHistoryModal}
        />
      </div>
      <Typography className={classes.centerSmall} variant="h5">
        <FormattedMessage {...messages.header} />
      </Typography>
      <CoursesOverview />
    </div>
  );
};

export default HomePage;
